import { HttpClient } from "@angular/common/http";
import { LacrosseEntity } from "../lacrosse.entity";
import { FirebaseAuthService } from "../../noizu/services/firebase-auth.service";

export class DeviceLookupTableEntryEntity extends LacrosseEntity {
  public _kind = "device-lookup";
  public _singular = "device-lookup";

  public series: string;
  public serial: string;
  public verification_code: string;

  constructor(client: HttpClient, auth: FirebaseAuthService, json) {
    super(client, auth, json);
  } // end constructor

  refresh(data) {
    this.series = data["series"];
    this.serial = data["serial"];
    this.verification_code = data["verification_code"];
    return super.refresh(data);
  }

  public toJson(options: any = { for: "appengine" }) {
    return {
      id: this.identifier,
      series: this.series,
      serial: this.serial,
      verification_code: this.verification_code,
    };
  }
}
